import { render, staticRenderFns } from "./ExamInternalFooter.vue?vue&type=template&id=226d5936&scoped=true&"
import script from "./ExamInternalFooter.vue?vue&type=script&lang=js&"
export * from "./ExamInternalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ExamInternalFooter.vue?vue&type=style&index=0&id=226d5936&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d5936",
  null
  
)

export default component.exports